/**
 * Curso Travel Empire / Club Viajemos — organizado por los 5 Secretos.
 *
 * Cada seccion contiene una o mas subcarpetas de Drive embebidas.
 * Los videos se reproducen DENTRO de la pagina (no salen a Drive).
 *
 * Para reorganizar: mueve los items entre los arrays de cada secreto.
 * Los IDs corresponden a las subcarpetas de la carpeta principal
 * 1guc7KEQgqOliD_a_PxCTEqFVHTZKCRY5
 */
export const COURSE_FOLDER_ID = "1guc7KEQgqOliD_a_PxCTEqFVHTZKCRY5";

export const SECRETOS = [
  {
    num: 1,
    titulo: "Certificados de Viaje",
    subtitulo: "La herramienta industrial mas poderosa del turismo moderno",
    descripcion: "No es un regalo de hotel: es una herramienta industrial de marketing disenada para llenar las salas de venta de los resorts del mundo. Cuando entiendes esto, dejas de regalar vouchers y empiezas a operar dentro de un sistema de miles de millones de dolares.",
    pdf_guide: "/docs/secretos/S1-certificados-de-viaje.pdf",
    color: "#80C753",
    folders: [
      { id: "1ozEzNINtrI7g0psyRoirzty94VK0JjLd", title: "Certiviaje" },
      { id: "15eKMrTIPotqz3K-dWjOng49WFfygLb8c", title: "Curso: Como vender certificados" },
      { id: "1WiiBLplqnyXHpGlkGkCvyqiip8e_a-zO", title: "Plataformas OTA" },
      { id: "1IZzzec6fiY6A5PSu6sOHDeG-mL11HQ1z", title: "Competencia del mercado: aprende a objetar" },
    ],
  },
  {
    num: 2,
    titulo: "Asesorias Migratorias",
    subtitulo: "El mercado del 90% que las agencias tradicionales ignoran",
    descripcion: "Preparacion profesional de visa B1/B2 con estrategia, acompanamiento y monetizacion con integridad. Convertis cada solicitud en una relacion de largo plazo y entras al segmento que ninguna agencia esta atendiendo.",
    pdf_guide: "/docs/secretos/S2-asesorias-migratorias.pdf",
    color: "#45A0EE",
    folders: [
      { id: "1OHTEoL4YvLHk7cj_B2kLJmCfa__Ox0jj", title: "1. Asesorias de Visa" },
    ],
  },
  {
    num: 3,
    titulo: "Agencia de Viajes OTA",
    subtitulo: "Las mismas tarifas mayoristas que usan Booking y Expedia",
    descripcion: "Acceso a las tarifas mayoristas que las grandes plataformas usan para construir sus margenes — ahora esa diferencia es tuya. Dejas de ser revendedor para operar como mayorista, con manual de carrera, IA, redes sociales y herramientas de prospeccion incluidas.",
    pdf_guide: "/docs/secretos/S3-agencia-ota.pdf",
    color: "#c9a227",
    folders: [
      { id: "1-r153J5rLjByGvp9W3JTZZu1OQFh7RWO", title: "Tipos de niveles de Agencia" },
      { id: "1N__RlpffxaOOKm-j5OXJozarmHFZV3Na", title: "Manual de Carrera" },
      { id: "11_OtArJdQfi85mfWED6KNwlu7Bdo8ggm", title: "Curso 3 Niveles: Luna de Miel" },
      { id: "1aBftUM3h23cYqlPnpa80A6A4IFuydAlk", title: "Herramientas de prospeccion con IA" },
      { id: "1jPW3oip7QNBE_I-2LSZ2nhwD9Id9l-g_", title: "Asistente virtual Club Viajemos" },
      { id: "1KX6PsAWF49Wq4211Ac-lUoA5EqWU04aP", title: "Redes Sociales: de cero a influencer" },
      { id: "191Xs0Q2zl3C5LLvlqSd8eW42KcRcXPMP", title: "Guiones para videos" },
      { id: "15YQI3Lqu6PtrTdRzC6nSEMYN3qtA2-MM", title: "OPC — Outside Public Contact" },
    ],
  },
  {
    num: 4,
    titulo: "Club Vacacional",
    subtitulo: "El producto premium para clientes de alto valor",
    descripcion: "Como presentar, presupuestar y cerrar membresias de Club Vacacional con clientes que ya conocen tu marca a traves de los secretos anteriores. El ticket mas grande del sistema, vendido con metodo profesional.",
    color: "#E04A6F",
    folders: [
      { id: "1vtIv-j2jrMmQe3pTtzO6VeAKjiK7leVS", title: "SECRETO N°4 — Club Vacacional" },
      { id: "1rOLXcsONrcEkmx6_XETI4IzglTeD3Skv", title: "Curso completo: Como vender Club Vacacional" },
    ],
  },
  {
    num: 5,
    titulo: "Compartir la Oportunidad",
    subtitulo: "Replica el sistema y construye tu red de lideres",
    descripcion: "Como invitar al modelo de negocio, formar lideres que repliquen el sistema y multiplicar tu ingreso a traves de webinars semanales, cierres en vivo y educacion continua.",
    color: "#9B5CFF",
    folders: [
      { id: "1cMP5x_3QDtzUe1JzZGa-RjhfXYlwt53W", title: "SECRETO N°5 — Compartir la oportunidad" },
      { id: "1pbMN84Qov62O8Ik7otZTWpj-h6KnBlga", title: "Grabaciones de cierres y educacion" },
      { id: "1XvmOdLMtHPMAp__inFr5Q7E4_AEOeekG", title: "Webinars semanales: Gana dinero como Lider" },
      { id: "1V3JifVTY5oUJefUEtlrLHQH65ozUIb9P", title: "Educacion Hotmart" },
    ],
  },
];

export const RECURSOS_EXTRA = {
  titulo: "Recursos y materiales extra",
  descripcion: "Imagenes, canvas y contratos descargables para tu trabajo diario.",
  folders: [
    { id: "1nZuxFmn3O-xMusd9_NiYMyBNtPGsa3U2", title: "Canvas variados" },
    { id: "18Fw-uZ8Y5MafoxN495S6wWs0VGdZ2QWr", title: "Imagenes" },
    { id: "1juxQ0UhcfB6HkeCjiHLtglGTeNu_-9E9", title: "Contratos de convertidores" },
  ],
};
